<div class="container MainOuter">
  <!-- Added by pradnesh -->
  <!-- <div class="QRBox" *ngIf="!IsMobile">
    <img
      src="../../assets/images/FloatingQR1.jpg"
      alt="QRCode"
      (click)="OpenModalForAppQR()" />
  </div> -->
  <div class="row mx-1">
    <div class="col-lg-6 col-md-6 col-sm-4 col-xs-12">
      <app-login-left-banner></app-login-left-banner>
      <div class="MobileImageOuter">
        <img
          src="../../assets/images/IFA/LoginPage.jpg"
          class="w-100"
          alt="Login info mobile image" />
      </div>
    </div>
    <span
      [ngClass]="{ ForWeb: IsMobile }"
      *ngIf="Companyname == 'IFA' && UserType == 3 && IsMobile"
      class="InvLogin"
      routerLink="/login"
      style="top: 580px !important">
      Go To MFD Login >
    </span>
    <span
      [ngClass]="{ ForWeb: !IsMobile }"
      *ngIf="Companyname == 'IFA' && UserType == 3 && !IsMobile"
      class="InvLogin"
      routerLink="/login">
      Go To MFD Login >
    </span>

    <span
      [ngClass]="{ ForWeb: !IsMobile }"
      *ngIf="Companyname == 'IFA' && UserType == 2"
      class="InvLogin"
      routerLink="/login/investor">
      Go To Investor Login >
    </span>

    <div class="col-lg-6 col-md-6 col-sm-8 col-xs-12">
      <div class="OnBoardingFormOuter">
        <div class="FormHeading" [ngClass]="IsMobile ? 'justify_center' : ''">
          <div style="margin-bottom: 24px">
            <p [ngClass]="IsMobile ? 'text_align' : ''">Hi, Welcome !</p>
            <span>Login to your Account</span>
          </div>
        </div>
        <div class="Signup MainForm">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-8 col-xs-12">
              <form
                autocomplete="off"
                [formGroup]="LoginForm"
                (ngSubmit)="onSubmit()">
                <div class="row">
                  <div class="col InputBoxOuter" [hidden]="UserType == 3">
                    <input
                      type="text"
                      formControlName="Username"
                      oninput="this.value = this.value.toUpperCase()"
                      autofocus
                      class="form-control CommonTextBox"
                      [ngClass]="{
                        'is-invalid': LoginSubmitted && r.Username.errors
                      }"
                      placeholder="Enter Username"
                      maxlength="10" />
                    <div
                      *ngIf="LoginSubmitted && r.Username.errors"
                      class="invalid-feedback">
                      <div *ngIf="r.Username.errors.required">
                        Username is required
                      </div>
                    </div>
                  </div>
                  <div class="col InputBoxOuter" [hidden]="UserType == 2">
                    <input
                      type="text"
                      formControlName="Username"
                      oninput="this.value = this.value.toUpperCase()"
                      autofocus
                      class="form-control CommonTextBox"
                      [ngClass]="{
                        'is-invalid': LoginSubmitted && r.Username.errors
                      }"
                      placeholder="Enter PAN"
                      maxlength="10" />
                    <div
                      *ngIf="LoginSubmitted && r.Username.errors"
                      class="invalid-feedback">
                      <div *ngIf="r.Username.errors.required">
                        PAN is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col InputBoxOuter">
                    <show-hide-password btnStyle="" [btnOutline]="false">
                      <input
                        type="password"
                        formControlName="Password"
                        class="form-control CommonTextBox"
                        [ngClass]="{
                          'is-invalid': LoginSubmitted && r.Password.errors
                        }"
                        placeholder="Enter Password"
                        maxlength="20" />
                      <div
                        *ngIf="LoginSubmitted && r.Password.errors"
                        class="invalid-feedback">
                        <div *ngIf="r.Password.errors.required">
                          Password is required
                        </div>
                        <div *ngIf="r.Password.errors.pattern">
                          Password contains atleast 1 numeric , 1 uppercase, 1
                          lowercase and 1 special character
                        </div>
                        <!--Password contains atleast 1 number, 1 uppercase, 1 lowercase and 1 special charactor (@$!%*?&#)-->
                      </div>
                    </show-hide-password>
                    <!-- <span *ngIf="UserType!=2" routerLink="/resetpassword-investor" routerLinkActive="active"
                                            class="ForgetPassLink" (click)="SendUserType()">
                                            Reset Password
                                        </span>
                                        <span *ngIf="UserType == 2" routerLink="/resetpassword-mfd" routerLinkActive="active"
                                            class="ForgetPassLink" (click)="SendUserType()">
                                            Reset Password
                                        </span> -->
                    <span
                      *ngIf="UserType != 2"
                      routerLink="/generate-password"
                      routerLinkActive="active"
                      class="ForgetPassLink"
                      (click)="SendUserType()">
                      Reset Password
                    </span>
                    <span
                      *ngIf="UserType == 2"
                      routerLink="/forgot-password"
                      routerLinkActive="active"
                      class="ForgetPassLink"
                      (click)="SendUserType()">
                      Reset Password
                    </span>
                  </div>
                </div>
                <!-- <div class="row" *ngIf="UserType!=2" [ngClass]="IsMobile ? 'mt-2':''">
                                    <div class="col InputBoxOuter">
                                        <div class="text-center">
                                            <div class="Links">Don't have an account? <a
                                                    routerLink="/client-preOnboading" routerLinkActive="active"> Create
                                                    Account</a>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->

                <div class="SubmitMarginTop">
                  <button *ngIf="!IsOptimoney" class="CommonSubmitButton w-100">
                    Login
                  </button>
                  <button *ngIf="IsOptimoney" class="CommonSubmitButton w-100">
                    Login
                  </button>
                </div>
                <div *ngIf="UserType != 2 && IsSubscribed" class="mt-3">
                  <button
                    class="CommonSubmitButton w-100 SignUp"
                    routerLink="/client-preOnboading"
                    routerLinkActive="active">
                    Sign Up
                  </button>
                </div>
              </form>
              <!-- <div class="CreateAccount">
                                <div *ngIf="!IsInvestor">
                                    Don't have a distributor account?
                                    <span class="BlueText" routerLink="/distributor-onboarding"
                                        routerLinkActive="active">Create Account</span>
                                </div>
                            </div> -->
            </div>
            <!-- <div *ngIf="IsShowLoginOption && !IsMobile" class="col-12 text-right">
                            <div class="WhoIAMLink">
                                I am <a (click)="ChangeType()">
                                    <span *ngIf="!IsInvestor">an <span class="BlueText">Investor</span></span>
                                    <span *ngIf="IsInvestor">a <span class="BlueText">Distributor</span></span>
                                </a>
                            </div>
                        </div> -->
          </div>
        </div>
      </div>

      <!-- <div *ngIf="!this.IsShowLoginOption" class=" MyImportantOuter d-flex justify-content-center mt-4 d-none" style="right:128px !important " >

          <a *ngIf="!IsOptimoney && !IsMobile" [href]="DownloadLink" target="_blank" class="CursorPointer MyImaportantNavLink" style="color: #7c51b3 !important; font-weight: 100;"><img style="width :auto;
            height : 49px !important;margin-left:80px;" src="../../assets/images/img/MobileAppDownload.png"  class="MobilAppimg" /></a>

          <a *ngIf="IsOptimoney  && !IsMobile" href="https://play.google.com/store/apps/details?id=com.optimum.client" target="_blank" class="CursorPointer MyImaportantNavLink" style="color: #7c51b3 !important; font-weight: 100;"><img style="width :auto;
            height : 49px !important;margin-left: 88px ! Important;" src="../../assets/images/img/MobileAppDownload.png"  class="MobilAppimg" /></a>

          <a *ngIf="IsOptimoney  && !IsMobile" href="https://apps.apple.com/in/app/optimoney-mutual-funds-app/id6470476406" target="_blank" class="CursorPointer MyImaportantNavLink" style="color: #7c51b3 !important; font-weight: 100;"><img style=" width: auto;
            height: 54px !important;
            padding: 0px 0px 4px 20px;" src="../../assets/images/img/ios-icon.svg"  class="MobilAppimg" /></a>
          </div> -->
    </div>
  </div>
</div>
<div style="padding: 120px 0px 0px 0px">
  <app-footer *ngIf="!IsOptimoney && !IsMobile"></app-footer>
</div>
<!-- The Modal End -->
